<template>
    <div v-if="!isSearch && category.level > 2 && categoryChildren.length > 0">
        <portal-mobile portal-to="category-level-four">
            <div class="sub-cat-nav__outer">
                <div class="d-none d-lg-block sub-cat-nav__title">
                    <strong>{{ $translate('OD3dprimaV2::Template.category') }}: {{ category.details[0].name }}</strong>
                </div>
                <ul class="list-unstyled sub-cat-nav__list">
                    <li v-for="category in categoryChildren">
                        <a class="sub-cat-nav__item"
                           :href="getCategoryUrl(category.url)"
                           :title="category.details[0].metaTitle || category.details[0].name">
                            {{ category.details[0].name }}
                        </a>
                    </li>
                </ul>
            </div>
        </portal-mobile>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: {
      category: {
          type    : Object,
          default : () => {}
      }
    },
    data() {
        return {
            isWaiting         : false,
            isInitiallyLoaded : false,
            isSearch          : App.isSearch
        };
    },
    computed: {
        ...mapState({
            categoryChildren: state => state.navigation.categoryChildren
        })
    },
    mounted() {
        if(!this.isSearch) {
            this.loadChunk();
        }
    },
    methods: {
        loadChunk() {
            if (!this.isWaiting) {

                this.isWaiting = true;

                this.$store.dispatch('loadCategoryChildrenChunk',
                    { categoryId: this.category.id, size: 99 })
                    .finally(() => {
                        this.isWaiting         = false;
                        this.isInitiallyLoaded = true;
                    });
            }
        },
        getCategoryUrl(url) {

            const trailingSlash = url[0] === '/' ? '' : '/';
            const prefix        = App.urls.includeLanguage ? `/${ App.language }${ trailingSlash }` : "";

            return prefix + url;
        }
    }
}
</script>
